import './ValidatedParameter.scss';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IParameterBoolean } from '../helpers/parameters.helpers';
import { ValidatedCheckboxInput } from './ValidatedCheckboxInput';

interface IProps {
  parameter: IParameterBoolean;
  fieldIndex: number;
  value: boolean;
  disabled?: boolean;
  onChange: () => void;
}

export const ValidatedBooleanParameter = observer((props: IProps): ReactElement => {
  const { parameter, fieldIndex, disabled, onChange, value } = props;
  const { t } = useTranslator();

  const { label, itemDescription } = parameter;
  return (
    <div className={`list-row ${fieldIndex === 0 ? 'first' : ''}`}>
      <div className='left training-failure-reason'>
        {itemDescription?.displayedName ?? itemDescription?.shortName ?? t(`params.${label}`)}
        {!!itemDescription?.description && (
          <FontAwesomeIcon
            icon={faInfoCircle}
            title={itemDescription.description}
          />
        )}
      </div>
      <div className='right right-form'>
        <ValidatedCheckboxInput
          checked={value}
          id={`model-${label}-boolean-field`}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
    </div>
  );
});
